import script from "./ResultPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultPage.vue?vue&type=script&setup=true&lang=ts"

import "./ResultPage.vue?vue&type=style&index=0&id=0ff2e7c3&scoped=true&lang=css"

import exportComponent from "D:\\myworkitem2022\\customquestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff2e7c3"]])

export default __exports__